import { Typography } from '@neo4j-ndl/react';
import cx from 'classnames';

import DatabaseAddCircleIcon from './database-add-circle-icon.svg';
import RemoteDatabaseIcon from './remote-database-icon.svg';

const Icon = {
  'database-add-circle': DatabaseAddCircleIcon,
  'remote-database': RemoteDatabaseIcon,
} as const;

type EmptyStateProps = { title: string; description: string } & (
  | { customIcon: React.ReactNode }
  | { icon: keyof typeof Icon }
);

export function EmptyState(props: React.PropsWithChildren<EmptyStateProps>) {
  return (
    <div className="flex flex-col items-center gap-1 text-center">
      <div className="text-palette-neutral-text-weakest my-2">
        {'customIcon' in props ? (
          props.customIcon
        ) : (
          <img
            className={cx(
              'h-12 w-12',
              {
                'database-add-circle': '',
                'remote-database': 'translate-x-[6px]',
              }[props.icon],
            )}
            src={Icon[props.icon]}
          />
        )}
      </div>
      <Typography as="p" variant="subheading-small" className="text-palette-neutral-text-default">
        {props.title}
      </Typography>
      <Typography as="p" variant="body-medium" className="text-palette-neutral-text-weak">
        {props.description}
      </Typography>
      {props.children === undefined || props.children === null ? null : (
        <Typography as="div" variant="body-medium" className="text-palette-neutral-text-weak mt-2">
          {props.children}
        </Typography>
      )}
    </div>
  );
}
